import React, { useCallback } from 'react';

import { IClick } from '~/src/features/movix-new';
import { ELABELS } from '~/src/features/movix-new/constants';
import { dataLayerPushButton } from '~/src/features/movix-new/utils';

import { MovixButton } from '~/src/features/movix-new/styled';
import * as ST from './styled';

interface IProps {
    handleClick: (data: IClick) => void,
}

const WatchNowPayAfter = ({ handleClick }: IProps): JSX.Element => {
    const handleClickDataLayerWrapper = useCallback(() => {
        handleClick({ label: ELABELS.watchNowPayLater });
        dataLayerPushButton(ELABELS.watchNowPayLater);
    }, []);

    return (
        <ST.Wrapper>
            <ST.CircleLight/>
            <ST.TextBlock>
                <ST.Title>
                    <h2>
                        Смотрите сейчас — <span>платите потом</span>
                    </h2>
                </ST.Title>
                <ST.Description>
                    Выбирайте удобный для вас период рассрочки:&nbsp;
                    на 6, 12, 24 или 36 месяцев.&nbsp;
                    Мы&nbsp;привезём, подключим и&nbsp;настроим приставку.
                </ST.Description>
                <ST.ButtonBlock>
                    <MovixButton
                        bType={'white'}
                        onClick={handleClickDataLayerWrapper}
                    >
                        Подключить в рассрочку
                    </MovixButton>
                </ST.ButtonBlock>
                <ST.BGImage position='left' src='static/images/movix-new/corparation-tv-min.png'/>
                <ST.BGImage position='right' src='static/images/movix-new/star-wars-tv-min.png'/>
            </ST.TextBlock>
            <ST.CardWrapper>
                <ST.StyledContainer>
                    <ST.Card>
                        <ST.CardTextBlock>
                            <ST.CardTitle>
                                Громкие премьеры
                                <br/>
                                онлайн-кинотеатров у вас дома
                            </ST.CardTitle>
                            <ST.CardDescription>
                                Более 100 000 фильмов и сериалов в подписках онлайн-кинотеатров.
                            </ST.CardDescription>
                        </ST.CardTextBlock>
                        <ST.ImageBlock>
                            <img src='/static/images/movix-new/ivi-start-else.png' alt='ivi-start'/>
                        </ST.ImageBlock>
                    </ST.Card>
                </ST.StyledContainer>
            </ST.CardWrapper>
        </ST.Wrapper>
    );
};

export default WatchNowPayAfter;
